
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import _ from 'lodash';
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

/**
 * Float THead is a jQuery plugin that allows us to create sticky header rows in tables
 */
import floatthead from 'floatthead';
window.$.fn.floatthead = floatthead;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import Axios from 'axios';

window.axios = Axios.create();
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */


// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration, CaptureConsole } from '@sentry/integrations';

/**
 * Set up the application state before bringing in any Vue components
 */

window.store = {
    state: {
        // Data store cart state
        cart: $('body').data('user-cart-items'),
        announcementMessage: '',
        mobileNavActive: false,
    },
    addCartItemAction(productId) {
        if (this.state.cart.findIndex(value => value.startsWith(productId)) === -1) {
            this.state.cart.push(productId);
        }
    },
    mergeCartItemsAction(productIdList) {
        let oldCart = this.state.cart;
        let difference = productIdList.filter(x => !oldCart.includes(x));

        let dataStore = this;
        difference.forEach(function (productId) {
            dataStore.state.cart.push(productId);
        })
    },
    removeCartItemAction(productId) {
        this.state.cart = _.without(this.state.cart, productId)
    },
    setAnnouncementMessageAction(message) {
        this.state.announcementMessage = message;
    },
    clearAnnouncementMessageAction() {
        this.state.announcementMessage = '';
    },
    // Enable the mobile nav
    enableMobileNav() {
        this.state.mobileNavActive = true;
    },
    // Disable the mobile nav
    disableMobileNav() {
        this.state.mobileNavActive = false;
    }
};

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 * Any Vue component added needs to be declared before the call to 'new Vue'
 */

import HotspotContainer from './components/HotspotContainer';
import SvgComponent from './components/SvgComponent';
import ComparisonTable from './components/ComparisonTable';
import StoreMap from './components/StoreMap';
import CartButton from './components/CartButton';
import CartCount from './components/CartCount';
import Announcement from './components/Announcement';
import ReportallOnline from './components/ReportallOnline';
import MobileNavTrigger from './components/MobileNavTrigger';
import MobileNavMenu from './components/MobileNavMenu';
import Tooltip from './components/Tooltip';
import AdvancedSearch from './components/AdvancedSearch';
import Tabs from './components/Tabs';
import Tab from './components/Tab';
import LoadingIndicator from "./components/LoadingIndicator";
import PopupModal from "./components/PopupModal";
import CardForm from "./components/CardForm";
import CountySearch from "./components/CountySearch";
import ExportLink from "./components/ExportLink";
import VueFlashMessage from 'vue-flash-message';
import FloatThead from './components/FloatThead';
import ExplicitRegion from "./components/ExplicitRegion";
import Autocomplete from "./components/Autocomplete";
import PortalVue from 'portal-vue';
import SortedTablePlugin from "vue-sorted-table";
import EditableTable from "./components/EditableTable";
import EditableInput from "./components/EditableInput";
import EditableSelect from "./components/EditableSelect";
import EditableTextarea from "./components/EditableTextarea";
import EditableButton from "./components/EditableButton";

require('vue-flash-message/dist/vue-flash-message.min.css');

Vue.component('hotspot-container', HotspotContainer);
Vue.component('svg-component', SvgComponent);
Vue.component('comparison-table', ComparisonTable);
Vue.component('store-map', StoreMap);
Vue.component('cart-button', CartButton);
Vue.component('cart-count', CartCount);
Vue.component('announcement', Announcement);
Vue.component('reportall-online', ReportallOnline);
Vue.component('mobile-nav-trigger', MobileNavTrigger);
Vue.component('mobile-nav-menu', MobileNavMenu);
Vue.component('tooltip', Tooltip);
Vue.component('advanced-search', AdvancedSearch);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('loading-indicator', LoadingIndicator);
Vue.component('popup-modal', PopupModal);
Vue.component('card-form', CardForm);
Vue.component('county-search', CountySearch);
Vue.component('export-link', ExportLink);
Vue.component('explicit-region', ExplicitRegion);
Vue.component('float-thead-table', FloatThead);
Vue.component('autocomplete', Autocomplete);
Vue.component('editable-table', EditableTable);
Vue.component('editable-input', EditableInput);
Vue.component('editable-select', EditableSelect);
Vue.component('editable-textarea', EditableTextarea);
Vue.component('editable-button', EditableButton);


Vue.use(VueFlashMessage);
Vue.use(PortalVue);
Vue.use(SortedTablePlugin);

Vue.prototype.$_ = _;

/**
 * Set up Sentry to report client side issues
 */
Sentry.init({
    dsn: 'https://85d937061a33473392b8e556b76982ad@sentry.io/4490027',
    integrations:
        [
            new VueIntegration({
                Vue,
                attachProps: true,
                logErrors: true
            }),
            new CaptureConsole({
                levels: ['error']
            }),
        ],
    release: 'js-release-27',
});

/**
 * Create Vue instance and save it to window variable
 */

window.vm1 = new Vue({
    el: '#app',
    data: {
        showModal: false
    },
    methods: {
        navigateTo: function (url) {
            window.location.href = url;
        }
    }
});

// Mail links

$('.mail-link').each(function () {
    let address = $(this).data("address");
    address = address.replace(" AT ", "@");
    address = address.replace(" DOT ", ".");

    if ( $(this).data("text") ) {
        $(this).text($(this).data("text"))
    } else {
        $(this).text(address);
    }
    $(this).attr("href", "mailto:" + address);
});


// Read more links used for bios

$('.read-more-link a').on("click", function (ev) {
    ev.preventDefault();
    if ($(this).data("active") === "true") {
        $(this).parent().attr("data-active", false);
        $(this).parent().siblings(".read-more-text").attr("data-active", false);
    } else {
        $(this).parent().attr("data-active", true);
        $(this).parent().siblings(".read-more-text").css("opacity", 0).attr("data-active", true).animate({ "opacity": 1 }, 250);
    }
});

// Local anchor links

$('a.local-link').on("click", function (ev) {
    ev.preventDefault();

    let main = $('.main');

    let el = $(this.getAttribute('href')),
        scrollTop = main.scrollTop();
    let offs = el.position();

    main.stop().animate({ scrollTop: offs.top + scrollTop },500);
});

// Accordion expander

$('a.accordion-toggle').on('click', function () {
    let id = $(this).data('accordion');
    let drawer = $(".accordion-drawer[data-accordion='" + id + "']");
    let toggle = $(".accordion-toggle[data-accordion='" + id + "']");
    if (typeof drawer.attr('state-open') !== 'undefined' && drawer.attr('state-open') === 'true') {
        drawer.attr('state-open', false);
        toggle.attr('state-open', false);
    } else {
        drawer.attr('state-open', true);
        toggle.attr('state-open', true);
    }
});
